export const Environment = {
  apiUrl: 'https://api.v2.thevillages.com/rest/homes',
  basicToken: 'Basic 64f7873ca215d1eb1f72a13f',
  community: 'villages',
  esriApiKey: 'runtimebasic,1000,rud000252796,none,MJJ47AZ7G349NERL1216',
  geoWithin: [
    [-82.15302089289051, 28.734967016349476],
    [-82.15302089289051, 28.979263747582383],
    [-81.80711132450716, 28.979263747582383],
    [-81.80711132450716, 28.734967016349476],
    [-82.15302089289051, 28.734967016349476],
  ],
  hostUrl: 'https://www.thevillages.com/homefinder',
  isApp: false,
  mapCenter: [-81.98006610869884, 28.85711538196593],
  mapConstraints: {
    geometry: {
      type: 'extent',
      xmax: -81.8071,
      xmin: -82.153,
      ymax: 28.9792,
      ymin: 28.722,
    },
    maxZoom: 18,
    minZoom: 1,
    rotationEnabled: false,
  },
  mapServer: 'https://arc7.thevillages.com/arcgis/rest/services/PUBLICMAP26/MapServer',
  mapUrl: 'https://api.v2.thevillages.com/rest/map',
  mapZoom: 1,
  production: true,
  safePaddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))',
  temperatureUrl: 'https://api.v2.thevillages.com/rest/weather/hourly/current',
  usersUrl: 'https://api.v2.thevillages.com/rest/users',
};
